import { Component, Vue, Watch } from 'vue-property-decorator';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import Loader from '@/components/Loader/index.vue';

library.add(faPlusCircle, faExternalLinkAlt);

interface AlphabetItem {
	showValue: string;
	searchValues: string[];
	matchValue: string;
}

@Component({
	components: {
		Loader,
	},
})
export default class TableGroups extends Vue {
	alphabetList: AlphabetItem[] = generateAlphabetList();

	created() {
		this.fetch()
	}

	async fetch() {
		await this.$store.dispatch('fetchReport', this.$route.params.clientId)
	}

	// @Watch('$route')
	// onRouteChange() {
	// 	this.fetchGroups();
	// }

	get items() {
		return this.$store.state.clients.groupsList;
	}

	getDomain() {
		if (window.location.host.includes('localhost:8735')) {
			return 'https://localhost:8735';
		}

		return '';
	}
}

function generateAlphabetList(): AlphabetItem[] {
	const list: AlphabetItem[] = [{
		showValue: '0 - 9',
		searchValues: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
		matchValue: '0',
	}];

	for (let i = 9; ++i < 36;) {
		const letter: string = i.toString(36);

		list.push({
			showValue: letter.toUpperCase(),
			searchValues: [letter],
			matchValue: letter,
		});
	}

	return list;
}
